import { CSSProperties, forwardRef } from "react";
import { createElement } from "react";
import { PropsWithChildren } from "react";

export const Flex = forwardRef<
  HTMLDivElement,
  PropsWithChildren<
    JSX.IntrinsicElements["div"] & {
      centered?: boolean;
      centeredX?: boolean;
      centeredY?: boolean;
      spaceBetween?: boolean;
      gap?: number;
      direction?: CSSProperties["flexDirection"];
      inline?: boolean;
      start?: boolean;
      wrap?: boolean;
      vertical?: boolean;
    }
  >
>(function Flex(props, ref) {
  const {
    centered,
    centeredX,
    centeredY,
    spaceBetween,
    gap,
    direction,
    inline,
    start,
    wrap,
    vertical,
    children,
    style: propStyles,
    ...childProps
  } = props;
  const style: CSSProperties = {
    display: `${inline ? "inline-" : ""}flex`,
    flexWrap: wrap ? "wrap" : undefined,
    justifyContent: spaceBetween
      ? "space-between"
      : start
      ? "flex-start"
      : "center",
    alignItems:
      centeredY === false ? "flex-start" : start ? "flex-start" : "center",
    gap: gap || 0,
    flexDirection: vertical ? "column" : direction || "row",
    ...propStyles,
  };
  return createElement("div", { ...childProps, style, ref }, children);
});
